import { Box, Button, Typography } from "@mui/material";
import React from "react";
import ContactData from "../main-details/contact-data";

const UrlDetails = ({ data }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        flexDirection: "column",
        width: "100%",
        gap: "30px",
      }}
    >
      {data?.screenShot ? (
        <div className="panel-img-container">
          <img src={data?.screenShot} alt="Panel" className="panel-img" />
        </div>
      ) : (
        <div className="panel-img-container"></div>
      )}
      <a
        href={data?.smmpanel_url}
        target="_blank"
        className={`flex w-full justify-center`}
      >
        <Button
          sx={{
            backgroundColor: "primary.main",
            color: "white",
            textAlign: "center",
            fontSize: "14px",
            cursor: "pointer",
            fontWeight: "bold",
            padding: 3,
            paddingY: 1,
            borderRadius: "0.25rem",
            "&:hover": {
              backgroundColor: "#114797",
            },
          }}
          //   onClick={() => window.open(Panel.url, "_blank")}
        >
          Visit Provider Website
          <svg
            width="20"
            height="20"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ marginLeft: "6px" }}
          >
            <g clip-path="url(#clip0_179_2758)">
              <path
                d="M9.41487 3.61514H6.91015C5.3515 3.61514 4.5716 3.61514 3.97628 3.91848C3.45262 4.18529 3.02718 4.61073 2.76037 5.1344C2.45703 5.72971 2.45703 6.50962 2.45703 8.06826V18.6438C2.45703 20.2024 2.45703 20.9814 2.76037 21.5766C3.02718 22.1003 3.45262 22.5265 3.97628 22.7932C4.57102 23.0963 5.34997 23.0963 6.90557 23.0963H17.4897C19.0452 23.0963 19.8231 23.0963 20.4178 22.7932C20.9415 22.5265 21.3684 22.0999 21.6351 21.5762C21.9382 20.9815 21.9382 20.2034 21.9382 18.6478V16.1388M23.3297 9.18119V2.22363M23.3297 2.22363H16.3722M23.3297 2.22363L13.5891 11.9642"
                stroke="white"
                stroke-width="3.03603"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_179_2758">
                <rect width="25" height="25" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </Button>
      </a>
      {data?.url_service && (
        <a href={data?.url_service} className="panel-description">
          <Typography className="panel-description">
            url service: {data?.url_service}
          </Typography>
        </a>
      )}
      {data?.smmpanel_loginuser && (
        <Typography className="panel-description">
          smmpanel login user: {data?.smmpanel_loginuser}
        </Typography>
      )}
      {data?.smmpanel_login_password && (
        <Typography className="panel-description">
          smmpanel login password: {data?.smmpanel_login_password}
        </Typography>
      )}
      {data?.smmpanel_api_key && (
        <Typography className="panel-description">
          smmpanel api key: {data?.smmpanel_api_key}
        </Typography>
      )}
      {data?.smmpanel_api_url && (
        <Typography className="panel-description">
          smmpanel api url: {data?.smmpanel_api_url}
        </Typography>
      )}
      {data?.smmpanel_ticket_numper && (
        <Typography className="panel-description">
          smmpanel ticket number: {data?.smmpanel_ticket_numper}
        </Typography>
      )}
      {data?.smmpanel_date_of_ticket && (
        <Typography className="panel-description">
          smmpanel date of ticket: {data?.smmpanel_date_of_ticket}
        </Typography>
      )}
    </Box>
  );
};

export default UrlDetails;
